
import { defineComponent, ref, watch } from "vue";

import { BaseInput } from "@tager/admin-ui";

import { setPriorityProduct } from "@/services/requests";

type Props = Readonly<{ id: number; priority: string }>;

export default defineComponent({
  name: "PriorityBlock",
  components: { BaseInput },
  props: {
    id: {
      type: Number,
      required: true,
    },
    priority: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const values = ref<{ priority: string }>({ priority: props.priority });
    watch(
      () => props.priority,
      () => {
        values.value.priority = props.priority;
      }
    );

    function updatePriority(priority: string) {
      priority
        ? setPriorityProduct(props.id, {
            value: Number(priority),
          }).then()
        : null;
    }

    return { updatePriority, values };
  },
});
